<template>
    <v-card tile width="768" elevation="0">
        <div class="py-3 px-6 d-flex align-center">
          <v-img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"  contain max-width="92" height="30"></v-img>
          <v-text-field solo rounded hide-details :value="config.keywords[0] || 'keyword'" class="ml-6">
            <template v-slot:append>
              <div class="d-flex">
                <v-icon class="mr-2">mdi-close</v-icon>
                <v-divider vertical class="mr-2"></v-divider>
                <v-icon class="mr-2">mdi-keyboard</v-icon>
                <v-icon class="mr-2">mdi-microphone</v-icon>
                <v-icon class="mr-2">mdi-cam</v-icon>
                <v-icon color="#1a73e8" class="">mdi-magnify</v-icon>
              </div>
            </template>
          </v-text-field>
        </div>
        <div class="px-6 d-flex">
          <div class="ml-12 pl-16">
            <div class="blue1--text text-body-2 py-2" style="box-shadow: inset 0 -3px 0 0 #1a73e8"><v-icon color="#1a73e8" class="ml-1" size="20">mdi-magnify</v-icon> {{$t('googleSearch.all')}}</div>
          </div>
          <div class="pl-3 text-body-2 grey--text py-2"><v-icon class="ml-1" color="grey darken-2" size="20">mdi-video-outline</v-icon>  {{$t('googleSearch.videos')}}</div>
          <div class="pl-3 text-body-2 grey--text py-2"><v-icon class="ml-1" color="grey darken-2" size="20">mdi-image-outline</v-icon>  {{$t('googleSearch.images')}}</div>
          <div class="pl-3 text-body-2 grey--text py-2"><v-icon class="ml-1" color="grey darken-2" small>mdi-tag-outline</v-icon>  {{$t('googleSearch.shopping')}}</div>
          <div class="pl-3 text-body-2 grey--text py-2"><v-icon class="ml-1" color="grey darken-2" small>mdi-dots-vertical</v-icon> {{$t('googleSearch.more')}}</div>
          <v-spacer></v-spacer>
          <div class="pl-3 text-body-2 grey--text py-2"> {{$t('googleSearch.settings')}}</div>
        </div>
        <v-divider></v-divider>
        <div class="pl-2">
        <div class="pr-6 pl-16 ml-16">
          <div class="text-body-2 grey--text py-3">
            {{$t('googleSearch.results')}}
          </div>
          <div class="py-3">
            <div class="text-body-2 black--text">
              {{$t('googleSearch.sponsored')}}
            </div>
            <div class="py-3">
              <div class="d-flex">
                <v-avatar color="#1a73e833" size="32">
                  <v-icon color="#1a73e8">mdi-earth</v-icon>
                </v-avatar>
                <div class="ml-2">
                  <div class="text-caption">{{$t('googleSearch.sponsoredLink')}}</div>
                  <div class="text-caption grey--text">{{`http://${$t('googleSearch.sponsoredLinkTitle')}`}}</div>
                </div>
              </div>
              <div class="text-title blue--text pt-1">{{$t('googleSearch.sponsoredLinkTitle')}}</div>
              <div class="text-caption">
                {{$t('googleSearch.sponsoredLinkText')}}
              </div>
            </div>
            <div class="py-3 mt-2">
              <div class="d-flex">
                <v-avatar color="#fcfcfc" size="32">
                  <v-img :src="config && config.logo ? config.logo : ''" width="28" height="28" contain></v-img>
                </v-avatar>
                <div class="ml-2">
                  <div class="text-caption">{{config.link}}.themediatrade.com</div>
                  <div class="text-caption grey--text">https://{{config && config.link ? config.link : 'www'}}.themediatrade.com</div>
                </div>
              </div>
              <div class="text-title blue--text pt-1">{{config && config.title ? config.title : ''}}</div>
              <div class="text-caption">
                {{ config.description }}
              </div>
            </div>
            <div class="py-3">
              <div class="d-flex">
                <v-avatar color="#2196F333" size="32">
                  <v-icon color="#1a0dab">mdi-web</v-icon>
                </v-avatar>
                <div class="ml-2">
                  <div class="text-caption">{{$t('googleSearch.sponsoredOrganicLink')}}</div>
                  <div class="text-caption grey--text">{{`http://${$t('googleSearch.sponsoredOrganicLink')}`}}</div>
                </div>
              </div>
              <div class="text-title blue--text pt-1">{{$t('googleSearch.sponsoredOrganicTitle')}}</div>
              <div class="text-caption">
                {{$t('googleSearch.sponsoredOrganicText')}}
              </div>
            </div>
          </div>
        </div>
    </div>
      </v-card>
</template>
<script>
export default {
    name: "GoogleSearch",
    data: () => ({

    }),
    props:{
        config: Object
        /* must required this structure: 
        {
            title: String,
            description: String,
            keywords: Array of strings,
            logo: String (URL of logo),
            link: String (uri of client)
        }

        */
    }
}
</script>
<style scoped>
.v-application .blue--text{
    color: #1a0dab !important;
}
.v-application .blue1--text{
    color: #1a73e8 !important;
}

</style>